import React from 'react';
import StyledTable from '@shared/components/StyledTable';

/**
 * @typedef {object} AppraisserObservationReportsTableProps
 * @property {Array<*>} data
 * @property {string} title
 * @property {boolean} loading
 * @property {(eventId: number, observeeId: number) => void} onDownloadFile
 */

/**
 * @param {AppraisserObservationReportsTableProps} props
 */
const AppraisserObservationReportsTable = props => {
  const { data, title, onDownloadFile, loading = false } = props;
  const columns = [
    {
      title: 'Organizational Units',
      dataIndex: 'orgUnitNames',
      width: '35%'
    },
    {
      title: 'Date',
      dataIndex: 'eventEndDate',
      width: '6rem'
    },
    {
      title: 'Role',
      dataIndex: 'observeeRole',
      width: '8rem'
    },
    {
      title: 'Observer/Coach',
      dataIndex: 'observerName',
      width: '20%'
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: '5rem'
    },
    {
      title: 'Download',
      dataIndex: 'fileName',
      width: '25%',
      render(value, record) {
        return <a onClick={() => onDownloadFile(record.eventId, record.observeeId)}>{value}</a>;
      }
    }
  ];

  return (
    <div>
      <h4>{title}</h4>
      <StyledTable
        rowKey='id'
        className='observation-reports-table'
        dataSource={data}
        columns={columns}
        showSorterTooltip={false}
        loading={loading}
        pagination={false}
      />
    </div>
  );
};

export default AppraisserObservationReportsTable;
